import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Text, Box, Flex } from 'roo-ui/components';

const BadgeText = styled(Text)`
  text-align: center;
  display: inline-block;
  text-transform: uppercase;
  font-weight: ${themeGet('fontWeights.bold')};
  white-space: nowrap;
  letter-spacing: 1px;
`;

const Base = ({ children, ...props }) => (
  <Flex>
    <BadgeText {...props}>{children}</BadgeText>
  </Flex>
);

Base.propTypes = {
  children: PropTypes.node.isRequired,
};

const Badge = Box.withComponent(Base);
Badge.displayName = 'Badge';
Badge.defaultProps = {
  ...Box.defaultProps,
  bg: 'brand.secondary',
  px: 1,
  py: 0,
  color: 'greys.charcoal',
};

Badge.info = styled(Badge)``;
Badge.info.displayName = 'Badge';
Badge.info.defaultProps = {
  ...Badge.defaultProps,
  bg: 'ui.infoBackground',
};

Badge.success = styled(Badge)``;
Badge.success.displayName = 'Badge';
Badge.success.defaultProps = {
  ...Badge.defaultProps,
  bg: 'ui.successBackground',
};

Badge.failure = styled(Badge)``;
Badge.failure.displayName = 'Badge';
Badge.failure.defaultProps = {
  ...Badge.defaultProps,
  bg: 'ui.errorBackground',
};

export default Badge;
